import React, { useEffect, useRef } from 'react';
import './Languages.css';

function Languages() {
  const tagsRef = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'scale(1)';
        }
      });
    }, observerOptions);

    tagsRef.current.forEach((tag, index) => {
      if (tag) {
        tag.style.opacity = '0';
        tag.style.transform = 'scale(0.8)';
        tag.style.transition = `all 0.5s ease-out ${index * 0.05}s`;
        observer.observe(tag);
      }
    });

    return () => observer.disconnect();
  }, []);

  const languages = [
    'अ Hindi',
    'A English',
    'ଆ Odia',
    'আ Bengali',
    'అ Telugu',
    'அ Tamil',
    'आ Marathi',
    'અ Gujarati',
    'ಅ Kannada',
    'അ Malayalam',
    'ਅ Punjabi',
    '+ & More...'
  ];

  return (
    <section className="languages" id="languages">
      <div className="languages-content">
        <h2 className="section-title">Speak Your Language</h2>
        <p className="section-subtitle">Talkbooks understands you, no matter which Indian language you speak</p>

        <div className="language-tags">
          {languages.map((language, index) => (
            <div
              key={index}
              className="language-tag"
              ref={el => tagsRef.current[index] = el}
            >
              {language}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Languages;

